/** 软删。选择器里 Cpt 直接 return null，计数也不算。 */
export const isDeletedComponent = (cpt) => Number(cpt?.state) === -1

const dlcIdSet = (dlcs) => {
  if (dlcs instanceof Set) return dlcs
  return new Set((dlcs ?? []).map((dlc) => dlc.id ?? dlc).filter(Boolean))
}

const layerIdSet = (layers) => {
  if (layers == null) return null
  if (layers instanceof Set) return layers
  const ids = new Set(
    (Array.isArray(layers) ? layers : []).map((layer) => layer.id ?? layer),
  )
  ids.add('draft')
  return ids
}

/**
 * 组件选择器三个分区（CptInLayer → DefalutCpts / CptsWithoutDlc / CptsInDlc）：
 * - 无 dlc → Miss DLC
 * - dlc === tid → 模板默认区
 * - dlc === 某个还在的 DLC id → 该 DLC 手风琴
 * 对不上的（DLC 已删等）三个分区都不渲染。
 */
export const belongsToVisibleDlcSection = (cpt, tid, dlcs) => {
  const dlc = cpt?.dlc
  if (!dlc) return true
  if (dlc === tid) return true
  return dlcIdSet(dlcs).has(dlc)
}

const matchesPickerLayer = (cpt, lid) => {
  if (lid === undefined || lid === null) return true
  if (lid && lid !== 'draft') return cpt.lid === lid
  return cpt.lid === 'draft' || !cpt.lid
}

/** 层列表里选不到的层，组件选择器也进不去，不算展示。 */
const belongsToSelectableLayer = (cpt, layers) => {
  const ids = layerIdSet(layers)
  if (!ids) return true
  const lid = cpt?.lid
  if (!lid || lid === 'draft') return true
  return ids.has(lid)
}

/**
 * 和网格里能看到的卡一致（Cpt 组件）：
 * 软删不展示；换色子件挂在父卡上不算多一张；dlc 对不上分区的不展示。
 */
export const isDisplayedPickerCard = (cpt, tid, dlcs) => {
  if (!cpt) return false
  if (isDeletedComponent(cpt)) return false
  if (cpt.pid) return false
  return belongsToVisibleDlcSection(cpt, tid, dlcs)
}

/**
 * @param lid 指定层（含 draft）；不传则跨层合计
 * @param layers 传入层列表时，lid 对不上现有层的不算（选择器进不去）
 */
export const displayedPickerCards = (cpts, tid, dlcs, lid, layers) =>
  (Array.isArray(cpts) ? cpts : []).filter(
    (cpt) =>
      isDisplayedPickerCard(cpt, tid, dlcs) &&
      matchesPickerLayer(cpt, lid) &&
      belongsToSelectableLayer(cpt, layers),
  )

/** 某个分区网格里实际画出的卡（已按层/dlc 筛过后再去掉子件）。 */
export const pickerGridCards = (cpts) =>
  (Array.isArray(cpts) ? cpts : []).filter(
    (cpt) => !isDeletedComponent(cpt) && !cpt.pid,
  )
